import React from 'react';
import { createPortal } from 'react-dom';

/**
 * 변경사항이 있는 모달을 닫으려 할 때(바깥 클릭·Esc·닫기) 확인.
 * 앱 공통 "나가기 확인" 모달(MainLayout 등 cp-leave-modal-*)과 같은 마크업·문구·버튼 배치.
 * 바깥 클릭·Esc = 취소(머무르기).
 */
const UnsavedChangesConfirmModal: React.FC<{
  open: boolean;
  title?: string;
  description?: string;
  /** 기본 '저장 하기' (편집기는 '등록 하기') */
  primaryLabel?: string;
  discardLabel?: string;
  onDiscard: () => void;
  onCancel: () => void;
  onPrimary: () => void;
  primaryDisabled?: boolean;
}> = ({
  open,
  title = '변경사항이 저장되지 않았습니다',
  description = '저장하지 않고 나가시겠습니까?',
  primaryLabel = '저장 하기',
  discardLabel = '저장하지 않고 나가기',
  onDiscard,
  onCancel,
  onPrimary,
  primaryDisabled = false,
}) => {
  const titleId = React.useId();
  React.useEffect(() => {
    if (!open) return undefined;
    const onKey = (ev: KeyboardEvent) => {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        ev.stopPropagation();
        onCancel();
      }
    };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [open, onCancel]);

  if (!open || typeof document === 'undefined') return null;
  return createPortal(
    <div
      className="cp-modal-backdrop cp-unsaved-confirm-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      onClick={onCancel}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <div className="cp-modal cp-leave-modal-box" onClick={(e) => e.stopPropagation()}>
        <h3 id={titleId} className="cp-leave-modal-title">
          {title}
        </h3>
        <p className="cp-leave-modal-desc">{description}</p>
        <div className="cp-modal-footer cp-leave-modal-actions">
          <button type="button" className="cp-btn-secondary" onClick={onDiscard} disabled={primaryDisabled}>
            {discardLabel}
          </button>
          <button type="button" className="cp-btn-primary" onClick={onPrimary} disabled={primaryDisabled}>
            {primaryLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UnsavedChangesConfirmModal;
